module.exports = __webpack_public_path__ + "img/devices.7add60d6.png";